// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { DefaultButton, PrimaryButton, Spinner, Stack } from '@fluentui/react';
import { FeedbackDialogPrivacyStatement } from './FeedbackDialog.privacystatement';

export const FeedbackDialogFooter = (props: {
  guid?: string;
  submitDisabled: boolean;
  submittingFeedback: boolean;
  onSubmit: () => void;
  onClose: () => void;
}): JSX.Element => (
  <Stack tokens={{ childrenGap: '0.5rem' }}>
    <Stack.Item>
      <FeedbackDialogPrivacyStatement />
    </Stack.Item>
    <Stack.Item>
      <Stack horizontal tokens={{ childrenGap: '1rem' }}>
        {!props.guid && (
          <Stack.Item>
            <PrimaryButton
              disabled={props.submitDisabled || props.submittingFeedback}
              onClick={props.onSubmit}
              text={props.submittingFeedback ? undefined : 'Submit'}
            >
              {props.submittingFeedback && <Spinner ariaLabel="Submitting Feedback" />}
            </PrimaryButton>
          </Stack.Item>
        )}
        <Stack.Item>
          <DefaultButton onClick={props.onClose} text="Close" />
        </Stack.Item>
      </Stack>
    </Stack.Item>
  </Stack>
);
